module.exports = __webpack_public_path__ + "static/media/(DH)-01-Capim-Dourado-bijuterias.bb0b488b.jpg";